import { render, staticRenderFns } from "./ProofreadingConfirmationDialog.vue?vue&type=template&id=5914b76e&scoped=true"
import script from "./ProofreadingConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingConfirmationDialog.vue?vue&type=style&index=0&id=5914b76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914b76e",
  null
  
)

export default component.exports